import { pushEvent } from 'src/client/data-layer';
import type { LayoutMode } from 'src/components/layout-buttons/types';

export const trackProductCollectionLayoutChangeClick = (
  from: LayoutMode,
  to: LayoutMode
) => {
  const fromAndToLayout = `${from} -> ${to}`;
  pushEvent('ProductCollectionLayoutChangeClick', {
    fromAndToLayout,
  });
  pushEvent('LayoutChange', {
    from,
    to,
  });
};
